module.exports = __webpack_public_path__ + "img/Uso de quebra vento em pomar de maçã 1.8edb0d5b.webp";